import React, { useState, useEffect } from "react";
import '../../components/ResetPassword/ResetPassword.css';
import { RxCross2 } from "react-icons/rx";
import { FaCheck } from "react-icons/fa";
import LoginModal from "../LoginModal/LoginModal";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ResetPassword = ({ isOpen, onClose }) => {
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

    useEffect(() => {
        if (isOpen) {
            toast.success("Your password has been successfully reset!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleSubmitClick = () => {
        setIsLoginModalOpen(true);
    };

    return (
        <div className="resetPasswordOverlay">
            <ToastContainer 
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            {!isLoginModalOpen && isOpen && (
                <div className="resetPasswordModal">
                    <div className="circleIconContainers">
                        <FaCheck className="tickIcon" />
                    </div>

                    <div className="headerforgets">
                        <h2 className="resetTitle">Your password has been successfully reset.</h2>
                    </div>
                    
                    <p className="resetTitle2">You can now login with your new password.</p>

                    <button className="loginBtn" onClick={handleSubmitClick}>
                        BACK TO LOGIN
                    </button>
                    <button className="closeModalBtn" onClick={onClose}>
                        <RxCross2 />
                    </button>
                </div>
            )}

            {isLoginModalOpen && (
                <LoginModal
                    isOpen={isLoginModalOpen}
                    onClose={() => setIsLoginModalOpen(false)}
                />
            )}
        </div>
    );
};

export default ResetPassword;